export function CompletedIcon() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6" cy="6" r="5.5" stroke="currentColor" />
      <g clipPath="url(#clip0_414_5660)">
        <circle
          cx="6"
          cy="6"
          r="5.5"
          transform="matrix(-1 0 0 1 12 0)"
          stroke="currentColor"
        />
      </g>
      <g clipPath="url(#clip1_414_5660)">
        <circle cx="6" cy="6" r="5.5" stroke="currentColor" />
      </g>
      <path d="M3.5 6.5L5.5 8L8.5 4" stroke="currentColor" />
      <defs>
        <clipPath id="clip0_414_5660">
          <rect
            width="6"
            height="12"
            fill="white"
            transform="matrix(-1 0 0 1 6 0)"
          />
        </clipPath>
        <clipPath id="clip1_414_5660">
          <rect width="6" height="12" fill="white" transform="translate(6)" />
        </clipPath>
      </defs>
    </svg>
  );
}
